export default "__VITE_ASSET__6Dwi06h8__"